/** <lucid-money data-cents data-currency>: an amount in the shop currency, converted to the visitor's currency with the
 * storefront rate and formatted for the page language. Used for shipping amounts of zones priced in EUR. */
class LucidMoney extends HTMLElement {
  connectedCallback() {
    const rate = Number(window.Shopify?.currency?.rate || 1);
    const cents = Math.round(Number(this.dataset.cents || 0) * rate);
    const currency = this.dataset.currency || window.Shopify?.currency?.active || 'EUR';
    if (!cents) return;
    try {
      this.textContent = new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency,
        minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
      }).format(cents / 100);
    } catch {
      this.textContent = String(Math.round(cents / 100));
    }
  }
}

if (!customElements.get('lucid-money')) customElements.define('lucid-money', LucidMoney);
